module.exports = __webpack_public_path__ + "img/trash.f084501c.svg";